import * as React from 'react';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";

const SaveShippingMethod = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { SetStatus, data } = props;

    const { siteUser, PreferenceType: { Default_Carrier } } = Constants
    const { avUserInfoData: { currentUser, salesOrg } } = System
    const [shippingAddressInfo,] = useReduxState({}, 'setShippingAddressInfo')

    const isCoreUser = currentUser === siteUser.CORE
    const loader = __check('PLACE_ORDER_API_CALL').status;

    const saveShipMethod = async () => {
        let params = {
            preferenceType: Default_Carrier,
            preferenceValue: data?.shipData?.id,
            preferenceFilter: (isCoreUser ? (salesOrg + "-" + (shippingAddressInfo?.id ? shippingAddressInfo?.id : data?.addressId)) : shippingAddressInfo?.id)
        }
        SetStatus(false)
        data?.ShippingMethodCallback(params)
    }

    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5"><strong>Save Shipping Method</strong></h3>
                    </div>
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            <>
                                <p className='mb-0 mt-3 text-center'><strong>Would you like to set your Shipping method as default?</strong></p>
                            </>
                            <>
                                <p className='mb-0 mt-3 text-center'>{data?.shipData?.carrierKey} - {data?.shipData?.carrierOption}</p>
                            </>

                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button disabled={loader} type="button" className="bs5 btn btn-secondary minw140"
                            onClick={() => {
                                SetStatus(false)
                                data?.ShippingMethodCallback()
                            }}>No
                        </button>
                        <button disabled={loader} type="button" className="bs5 btn btn-primary minw140" onClick={saveShipMethod}>
                            {loader ? <i className="fa fa-spinner fa-spin" /> : "Yes"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SaveShippingMethod;
